import type {
  ChannelShiftAdminDto,
  ChannelShiftPeriodAdminDto,
  ChannelWorkingHoursAdminDto
} from '@/backend/market'
import { mapEntityProperties } from '@/utils/mapEntityProperties'
import {
  ChannelShiftEntity,
  ChannelShiftPeriodEntity,
  ChannelWorkingHoursEntity
} from '../../domain/entities/ChannelWorkingHoursEntity'

class ChannelShiftPeriodModel extends ChannelShiftPeriodEntity {
  constructor(data: ChannelShiftPeriodAdminDto) {
    super()
    mapEntityProperties<ChannelShiftPeriodModel>(this, data)
  }
}

class ChannelShiftModel extends ChannelShiftEntity {
  constructor(data: ChannelShiftAdminDto) {
    super()
    mapEntityProperties<ChannelShiftModel>(this, data, {
      map: {
        periods: data.periods?.map((period) => new ChannelShiftPeriodModel(period)) ?? []
      }
    })
  }
}

export class ChannelWorkingHoursModel extends ChannelWorkingHoursEntity {
  constructor(data: ChannelWorkingHoursAdminDto) {
    super()
    mapEntityProperties<ChannelWorkingHoursModel>(this, data, {
      map: {
        shiftDays: data.shiftDays?.map((day) => new ChannelShiftModel(day)) ?? []
      }
    })
  }
}
